import { useMutation } from 'react-query';
import {
  upsertMarketForAdmin,
  upsertMarketInReviewForAdmin,
} from '../api/MarketsEndpoints';

export const useUpsertMarket = () => useMutation(upsertMarketForAdmin);
export const useUpsertMarketInReviewForAdmin = () =>
  useMutation(upsertMarketInReviewForAdmin);
